export default "__VITE_ASSET__B867OMv8__"